import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  CanonicalTopicsTimelineResponseDataSchema,
  ClusterDomainSchema,
  DataResponse,
} from "schema"
import z from "zod"

type Response = DataResponse<z.infer<typeof CanonicalTopicsTimelineResponseDataSchema>>

type Props = {
  query: {
    domain: z.infer<typeof ClusterDomainSchema>
    segmentId?: string
    goalId?: string
    groupNonCategoryTopics?: boolean
  }
  enabled?: boolean
  onSuccess?: (data: z.infer<typeof CanonicalTopicsTimelineResponseDataSchema>) => void
}

export const CanonicalTopicsTimelineQuery = ({ query, enabled, onSuccess }: Props) => {
  return queryOptions({
    queryKey: ["canonical-topics", "timeline", JSON.stringify(query)],
    queryFn: async () => {
      const response = await axios.get<Response>(`/insights/canonical-topics/timeline`, {
        params: query,
      })

      onSuccess?.(response.data.data)

      return response.data.data
    },
    enabled,
  })
}
